import React from "react";
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from "recharts";
import dayjs from "dayjs";
import { pivotForStackedBars, unique, toNumber } from "../utils/chartTransforms";

const EvolucaoFornecedoresStacked = ({ data = [], colors = [], height = 400, stacked = false }) => {
  const prepared = pivotForStackedBars(
    data.map((r) => ({ ...r, value: toNumber(r.value) }))
  );
  const fornecedores = unique(data.map((d) => d.name));

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={prepared}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="data" tickFormatter={(v) => dayjs(v).format("DD/MM")} />
        <YAxis />
        <Tooltip
          labelFormatter={(v) => dayjs(v).format("DD/MM/YYYY")}
          formatter={(val, key) => [`${val} NCEs`, key]}
        />
        <Legend />
        {fornecedores.map((forn, i) => (
          <Bar key={forn} dataKey={forn} 
        //   stackId={stacked ? "nce" : undefined} 
          fill={colors[i % colors.length]} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default EvolucaoFornecedoresStacked;
